import { axios } from '@/utils/request'
import qs from 'qs'

/**
 * 专家端api
 */
const expertApi = {

  getExpertByUserId: '/api/1/expert/get_expert_by_user_id.json',

  queryExpertAllWorkRecordByUserIdList: '/api/1/expert/query_expert_all_work_record_list_by_user_id.json',

  queryExpertReviewActiveNoticeListByUserIdList: '/api/1/expert/query_expert_review_active_notice_list_by_user_id',

  getExpertByOutUserId: '/api/1/expert/get_expert_by_out_user_id.json',

  expertLeaveBySelf: '/api/1/expert/expertLeave',

  expertSetNotExtractTime: '/api/1/expert/setNotExtractTime',

  setLeaveRecordTime: '/api/1/expert_leave_record/setLeaveRecordTime',

  setTerminationLeave: '/api/1/expert_leave_record/setTerminationLeave',

  getExpertLeaveRecordByExpertId: '/api/1/expert_leave_record/getExpertLeaveRecordByExpertId',

  deleteExpertLeaveRecordByValid: '/api/1/expert_leave_record/deleteDetailByValid',

  editBankAccount: '/api/1/expertmain/expertInfo/editBankAccount',

  editMobilePhone: '/api/1/expertmain/expertInfo/editMobilePhone',

  saveOutApplyFor: '/api/1/expert_out_apply_for/saveOutApplyFor',

  withdrawOutApplyFor: '/api/1/expert_out_apply_for/withdrawOutApplyFor',

  getOutApplyForByExpertId: '/api/1/expert_out_apply_for/getOutApplyForByExpertId',

  setParticipationStatus: '/api/1/expert/setParticipationStatus',

  addOrUpdateEditPurchaseItemApplyFor: '/api/v1/expert_edit_purchase_item_apply_for/addOrUpdateEditPurchaseItem',

  revocationEditPurchaseItemApplyFor: '/api/v1/expert_edit_purchase_item_apply_for/revocationEditPurchaseItemApplyFor',

  getEditPurchaseItemApplyForById: '/api/v1/expert_edit_purchase_item_apply_for/getById',

  getEditPurchaseItemList: '/api/v1/expert_edit_purchase_item_apply_for/getEditPurchaseItemList'
}

/**
 * 管理端专家api
 */
const manageExpertApi = {

  addExpertInfo: '/api/1/expertmain/expertInfo/addExpertInfo',

  checkUpdateExpertInfo: '/api/1/expertmain/expertInfo/checkUpdateExpertInfo',

  getExpertInfo: '/api/1/expertmain/expertInfo/get_expert_info.json',

  getExpertInfoView: '/api/1/expertmain/expertInfo/getExpertInfoView',

  deleteExpertInfo: '/api/1/expertmain/expertInfo/delete_expert_info.json',

  queryExpertInfo: '/api/1/expertmain/expertInfo/queryExpertInfo',

  replaceExpertItem: '/api/1/expertmain/expertInfo/replace_expert_item.json',

  queryAppointExpertInfo: '/api/1/expertmain/expertInfo/query_appoint_expert_info.json',

  getExpertNumByItemCode: '/api/1/expertmain/expertInfo/getExpertNumByItemCode',

  setExpertStockOut: '/api/1/expertmain/expertInfo/set_expert_stock_out.json',

  getExpertStorageApplicationAuditData: '/api/v1/expert_storage_application/getAuditData',

  getOutApplyForAll: '/api/1/expert_out_apply_for/getOutApplyForAll',

  auditExpertOutApplyFor: '/api/1/expert_out_apply_for/auditExpertOutApplyFor',

  queryExpertWorkRecordList: '/api/1/expertmain/extractExpert/queryExpertWorkRecordList',

  queryExpertLeaveRecord: '/api/1/expertmain/expertInfo/queryExpertLeaveRecord',

  updateRemarkExpertById: '/api/1/expertmain/expertInfo/updateRemarkExpertById',

  updateStateExpertById: '/api/1/expertmain/expertInfo/updateStateExpertById',

  getExpertNameByIds: '/api/1/expertmain/expertInfo/getExpertNameByIds',

  getExpertInfoList: '/api/1/expertmain/expertInfo/getExpertInfoList',

  checkExpertIdCard:'/api/1/expertmain/expertInfo/checkExpertIdCard',

  checkExpertMobile: '/api/1/expertmain/expertInfo/checkExpertMobile',

  getProfessionalTitleList: '/api/1/fxDictionaryItem/getProfessionalTitleList',
}
//外部专家登记api
const outExpertApi = {
  //外部专家登记保存
  saveOutExpert: '/api/v1/expert_storage_application/saveStorageExpert',
  //校验手机号码是否已经在专家库
  checkMobilePhone: '/api/v1/expert_storage_application/checkMobilePhone',
  //校验身份证号码是否已经在专家库
  checkIdCard: '/api/v1/expert_storage_application/checkIdCard',
}

/**
 *  根据用户获取专家信息(后台获取登录用户查询)
 * @param details 是否详细 1为是
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const GetExpertByUserId = (details) => axios.get(expertApi.getExpertByUserId, { params: { details } })

/**
 *  根据用户获取专家对应的项目信息
 * @param query
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const QueryExpertAllWorkRecordByUserIdList = (query) => axios.get(expertApi.queryExpertAllWorkRecordByUserIdList, { params: { ...query } })

/**
 *  根据用户获取专家对应的评审活动通知
 * @param query
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const QueryExpertReviewActiveNoticeListByUserIdList = (query) => axios.get(expertApi.queryExpertReviewActiveNoticeListByUserIdList, { params: { ...query } })

/**
 *  根据用户获取专家信息（通过页面传参）
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const GetExpertByOutUserId = (userId) => axios.get(expertApi.getExpertByOutUserId, { params: { userId } })
/**
 *
 * @param expert 专家信息
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const QueryExpertInfo = (expert) => axios.get(manageExpertApi.queryExpertInfo, { params: { ...expert } })
/**
 *
 * @returns {AxiosPromise<any>}
 * @constructor
 * @param data 替换参数
 */
export const ReplaceExpertItem = (data) => axios.post(manageExpertApi.replaceExpertItem, qs.stringify(data))

/**
 * 指定抽取专家列表
 * @param expert 查询参数
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const QueryAppointExpertInfo = (expert) => axios.get(manageExpertApi.queryAppointExpertInfo, { params: { ...expert } })

/**
 * 获取单个品目下专家数量
 * @param expert 查询参数
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const GetExpertNumByItemCode = (params) => axios.get(manageExpertApi.getExpertNumByItemCode, { params: { ...params } })


/**
 * 添加专家
 * @param expert 专家信息
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const AddExpertInfo = (expert) => axios.post(manageExpertApi.addExpertInfo, qs.stringify(expert))

/**
 *  编辑专家
 * @param expert 专家信息
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const CheckUpdateExpertInfo = (expert) => axios.post(manageExpertApi.checkUpdateExpertInfo, qs.stringify(expert))

/**
 *  获取专家信息
 * @returns {AxiosPromise<any>}
 * @constructor
 * @param id 专家id
 */
export const GetExpertInfo = (id) => axios.get(manageExpertApi.getExpertInfo, { params: { id } })

/**
 * 获取专家详情
 * @param id 专家id
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const GetExpertInfoView = (id) => axios.get(manageExpertApi.getExpertInfoView, { params: { id } })

/**
 *  逻辑删除专家信息
 * @returns {AxiosPromise<any>}
 * @constructor
 * @param id 专家id
 */
export const DeleteExpertInfo = (id) => axios.post(manageExpertApi.deleteExpertInfo, qs.stringify({ id: id }))

/**
 * 设置出库专家
 * @param expertList 出库专家
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const SetExpertStockOut = (expertList) => axios.post(manageExpertApi.setExpertStockOut, qs.stringify(expertList, { allowDots: true }))

/**
 *  专家自己请假
 * @param data
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const ExpertLeaveBySelf = (data) => axios.post(expertApi.expertLeaveBySelf, data)

/**
 *  设置不抽取时间区间
 * @param data
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const ExpertSetNotExtractTime = (data) => axios.post(expertApi.expertSetNotExtractTime, qs.stringify(data))

/**
 *  专家设置休假时间区间
 * @param data
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const SetLeaveRecordTime = (data) => axios.post(expertApi.setLeaveRecordTime, qs.stringify(data))

/**
 *  专家结束休假时间
 * @param data
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const SetTerminationLeave = (data) => axios.post(expertApi.setTerminationLeave, qs.stringify(data))

/**
 *  根据专家ID和状态获取休假记录
 * @param expertId 专家ID
 * @param state 状态
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const GetExpertLeaveRecordByExpertId = (expertId, state) => axios.get(expertApi.getExpertLeaveRecordByExpertId, {
  params: {
    expertId: expertId,
    state: state
  }
})

/**
 * 删除有效的休假记录
 * @param data  休假信息
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const DeleteExpertLeaveRecordByValid = (data) => axios.post(expertApi.deleteExpertLeaveRecordByValid, qs.stringify(data))
/**
 * 外部专家登记
 * @param outExpert 专家信息
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const SaveOutExpert = (outExpert) => axios.post(outExpertApi.saveOutExpert, outExpert)

/**
 * 外部专家登记--校验手机号码是否已经在专家库
 * @param mobilePhone 手机号码
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const CheckMobilePhone = (mobilePhone) => axios.post(outExpertApi.checkMobilePhone, qs.stringify({ mobilePhone: mobilePhone }))

/**
 * 外部专家登记--校验身份证号码是否已经在专家库
 * @param idCard 身份证号码
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const CheckIdCard = (idCard) => axios.post(outExpertApi.checkIdCard, qs.stringify({ idCard: idCard }))

/**
 * 审核数据--获取专家入库申请表数据
 * @param formData 查询表单数据
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const GetExpertStorageApplicationAuditData = (formData) => axios.get(manageExpertApi.getExpertStorageApplicationAuditData, { params: { ...formData } })

/**
 *专家修改手机号码
 * @param formData 表单数据
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const EditMobilePhone = (formData) => axios.post(expertApi.editMobilePhone, qs.stringify(formData))

/**
 *专家修改银行信息
 * @param formData 表单数据
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const EditBankAccount = (formData) => axios.post(expertApi.editBankAccount, qs.stringify(formData))

/**
 * 专家提交出库申请
 * @param formData 表单数据
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const SaveOutApplyFor = (formData) => axios.post(expertApi.saveOutApplyFor, formData)

/**
 * 专家撤销出库申请
 * @param expertId 专家ID
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const WithdrawOutApplyFor = (expertId) => axios.post(expertApi.withdrawOutApplyFor, qs.stringify({ expertId }))

/**
 * 根据专家ID获取专家出库申请记录
 * @param expertId 专家id
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const GetOutApplyForByExpertId = (expertId) => axios.get(expertApi.getOutApplyForByExpertId, { params: { expertId } })

/**
 * 根据查询表单查询所有专家出库申请
 * @param expertOutApplyForQueryDto 查询表单
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const GetOutApplyForAll = (expertOutApplyForQueryDto) => axios.get(manageExpertApi.getOutApplyForAll, { params: expertOutApplyForQueryDto })

/**
 * 审核专家出库申请
 * @param formData 表单数据
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const AuditExpertOutApplyFor = (formData) => axios.post(manageExpertApi.auditExpertOutApplyFor, formData)

/**
 * 专家在系统上点击同意参加或不参加
 * @param selectExtractExpertVo 抽取数据
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const SetParticipationStatus = (selectExtractExpertVo) => axios.post(expertApi.setParticipationStatus, selectExtractExpertVo)

/**
 *  获取专家工作记录
 * @returns {AxiosPromise<any>}
 * @param data
 */
export const QueryExpertWorkRecordList = (data) => axios.get(manageExpertApi.queryExpertWorkRecordList, { params: { ...data } })
/**
 *  获取专家休假记录
 * @returns {AxiosPromise<any>}
 * @param data
 */
export const QueryExpertLeaveRecord = (data) => axios.get(manageExpertApi.queryExpertLeaveRecord, { params: { ...data } })

/**
 *  修改专家备注
 * @param data
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const UpdateRemarkExpertById = (data) => axios.post(manageExpertApi.updateRemarkExpertById, qs.stringify(data))

/**
 *  修改专家状态
 * @param data
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const UpdateStateExpertById = (data) => axios.post(manageExpertApi.updateStateExpertById, qs.stringify(data))
/**
 *  根据专家ID获取专家名称
 * @param data
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const GetExpertNameByIds = (data) => axios.post(manageExpertApi.getExpertNameByIds, data)
/**
 *  获取专家列表
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const GetExpertInfoList = (expertName) => axios.get(manageExpertApi.getExpertInfoList, { params: { expertName } })

/**
 *  校验专家手机号码
 * @param mobile 手机号码
 * @param id 专家id
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const CheckExpertMobile = (mobile,id) => axios.get(manageExpertApi.checkExpertMobile, { params: { mobile,id } })
/**
 *  校验专家身份证号码
 * @param idCard 身份证
 * @param id 专家id
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const CheckExpertIdCard = (idCard,id) => axios.get(manageExpertApi.checkExpertIdCard, { params: { idCard,id } })

/**
 * 专家提交修改评审品目申请
 * @param formData 申请数据
 * @returns {AxiosPromise<any>}
 * @constructor
 **/
export const AddOrUpdateEditPurchaseItemApplyFor = (formData) => axios.post(expertApi.addOrUpdateEditPurchaseItemApplyFor, formData)

/**
 * 专家撤回修改评审品目申请
 * @param purchaseItemApplyForId 申请ID
 * @returns {AxiosPromise<any>}
 * @constructor
 **/
export const RevocationEditPurchaseItemApplyFor = (purchaseItemApplyForId) => axios.post(expertApi.revocationEditPurchaseItemApplyFor,  qs.stringify({ id:purchaseItemApplyForId}))

/**
 * 根据id获取修改评审品目申请
 * @returns {AxiosPromise<any>}
 * @constructor
 **/
export const GetEditPurchaseItemApplyForById = (id) => axios.get(expertApi.getEditPurchaseItemApplyForById, { params: { id } })

/**
 * 根据专家ID以及审核状态获取修改评审品目申请列表
 * @returns {AxiosPromise<any>}
 * @constructor
 **/
export const GetEditPurchaseItemList = (expertId,auditStatus) => axios.get(expertApi.getEditPurchaseItemList, { params: { expertId:expertId, auditStatus:auditStatus } })

/**
 * 获取专家职称列表
 * @param level
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const GetProfessionalTitleList = () => axios.get(manageExpertApi.getProfessionalTitleList)
